var _path, _path2, _path3, _path4, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGg = function SvgGg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M256 0h128v480H256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M0 176h640v128H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "gg_svg__a",
    fill: "#f9dd16",
    d: "m110 286.7 23.3-23.4h210v-46.6h-210L110 193.3z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg_svg__a",
    width: 36,
    height: 24,
    transform: "rotate(90 320 240)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg_svg__a",
    width: 36,
    height: 24,
    transform: "rotate(-90 320 240)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gg_svg__a",
    width: 36,
    height: 24,
    transform: "rotate(180 320 240)"
  })));
};
export default SvgGg;